import { createSlice } from "@reduxjs/toolkit";
import { FIELD_NOTE_OPERATION_TYPES } from "../../../components/forms/noteForm/constants";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: false,
  operationType: null,
};

const fieldNoteSlice = createSlice({
  name: "fieldNote",
  initialState,
  reducers: {
    // create
    createFieldNoteStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createFieldNoteSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
      state.operationType = FIELD_NOTE_OPERATION_TYPES.CREATE;
    },
    createFieldNoteFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetFieldNoteState() {
      return initialState;
    },
    // update
    updateFieldNoteStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateFieldNoteSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
      state.operationType = FIELD_NOTE_OPERATION_TYPES.UPDATE;
    },
    updateFieldNoteFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    // delete
    deleteFieldNoteStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteFieldNoteSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
      state.operationType = FIELD_NOTE_OPERATION_TYPES.DELETE;
    },
    deleteFieldNoteFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const {
  createFieldNoteStart,
  createFieldNoteSuccess,
  createFieldNoteFailure,
  resetFieldNoteState,
  updateFieldNoteStart,
  updateFieldNoteSuccess,
  updateFieldNoteFailure,
  deleteFieldNoteStart,
  deleteFieldNoteSuccess,
  deleteFieldNoteFailure,
} = fieldNoteSlice.actions;

export default fieldNoteSlice.reducer;
